import React, { useState, useEffect } from "react";
import { MsgToCar, SelectTagCar } from "../MapStyled";
import { useHookstate } from "@hookstate/core";
import { Button, Modal } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import {
  MAP_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
  UPDATED_CAR_DATA_STATE,
  APP_CONSTANTS_STATE,
  COMMON_COMPONENTS_STATES,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  CAR_NUMBER_MESSAGE
} from "globalStore/globalStore";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

// Icons Imports Start
import { Tooltip } from "@mui/material";
import TimeFilterIcon from "assets/svgIcons/TimeFilterIcon";
import BatteryFilterIcon from "assets/svgIcons/BatteryFilterIcon";
import FilterCarIcon from "assets/svgIcons/FilterCarIcon";
import FilterFlagIcon from "assets/svgIcons/FilterFlagIcon";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import FilterShildIcon from "assets/svgIcons/FilterShildIcon";
import FilterDineIcon from "assets/svgIcons/FilterDineIcon";
import FilterBlockIcon from "assets/svgIcons/FilterBlockIcon";
import FilterTagsIcon from "assets/svgIcons/NotCommunicating";
import SearchIcon from "assets/svgIcons/SearchIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { isValidLocation } from "_helperFunctions/isValidLocation";
import moment from "moment";
import CloseIcon from "../../../../../assets/svgIcons/CloseIcon";
import { useFilteredCarsHook } from "customHooks/useFilterData";
import { useTranslation } from "react-i18next";
import { ChangeSettingsForSelectedCars } from "./ChangeSettingsForSelectedCars";
import { isUserAdmin, isUserSupport, getFeatureSetOption, getFeaturesList, carType, deviceType, holeLocation, memberCarTrackingLevel } from "constant";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";

const style = {
  position: "fixed",
  maxWidth: "420px",
  width: "100%",
  bgcolor: "#ffffff",
  top: "10%",
  right: "0",
  left: "0",
  border: "0 solid #000",
  margin: "0 auto",
};

let filteredData = [];

// Icons Import End
export const TagCarsComponent = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { selectedCarList, selectedCarList2 } = useHookstate(FLEET_GLOBAL_STATES);
  const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const {
    carsForMessagesGetter,
    carsGpsSelectorData,
    carsForMessagesGetter2,
    carsGpsSelectorData2,
  } = useHookstate(CAR_NUMBER_MESSAGE);

  const {
    showTagCarsState,
    showTagCarsFromMapState,
    findCars
  } = useHookstate(COMMON_COMPONENTS_STATES);

  const {
    allTaggedCars,
    highlightTagCar,
    showTaggedCarArray,
    showTaggedCarArrayLength,
    taggedCarsSaverGlobalState,
    taggedCarsDisplayerGlobalState,
    taggedCarsSaverGlobalStateMaintainer,
  } = useHookstate(MAP_GLOBAL_STATES);

  const { getUserRole, siteSettingsData } = useSelector((state) => state.commonReducers) || [];

  const enableMemberCar = (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || (!getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  ) && siteSettingsData?.MemberCarTrackingLevel != memberCarTrackingLevel.Never));

  const siteIdGetter = siteId.get();

  const [fleetCars, setFleetCars] = useState(true);
  const [specialCars, setSpecialCars] = useState(true);
  const [marshalCars, setMarshalCars] = useState(true);
  const [beverageCars, setBeverageCars] = useState(true);
  const [notInUseCars, setNotInUseCars] = useState(true);
  const [carsNotCommunicating, setCarsNotCommunicating] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [highlightCar, setHighlightCar] = useState([]);
  const [filterIconColor, setFilterIconColor] = useState(false);
  const [filterIconColorTime, setFilterIconColorTime] = useState(false);
  const [filterIconColorBattery, setFilterIconColorBattery] = useState(false);
  const [filterIconColorBatteryRed, setFilterIconColorBatteryRed] = useState(false);
  const [tempCar, setTempCar] = useState([]);
  const [carsToDisplay, setCarsToDisplay] = useState([]);
  const [carsType, setCarsTypeData] = useState([1, 3, 2, 4, 5, 6]);
  const [memberCars, setMemberCars] = useState(enableMemberCar);
  const [memberSpecialCars, setMemberSpecialCars] = useState(enableMemberCar);
  const [updateShowTaggedCarArrayLength, setUpdateShowTaggedCarArrayLength] = useState(false);

  const { getSelectedCarsState } = useFilteredCarsHook({
    marshalCars: marshalCars,
    specialCars: specialCars,
    memberCars: memberCars,
    memberSpecialCars: memberSpecialCars,
    beverageCars: beverageCars,
    fleetCars: fleetCars,
    notInUseCars: notInUseCars,
    notCommunicatingCars: carsNotCommunicating,
    paceWarning: filterIconColor,
    paceCritical: filterIconColorTime,
    batteryWarning: filterIconColorBattery,
    batteryCritical: filterIconColorBatteryRed,
    carsInEnergySaverMode: true
  });

  const { pathname } = useLocation();

  const carStatusData = [
    {
      id: 1,
      iconName: (
        <TimeFilterIcon
          bg={
            filterIconColor
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            filterIconColor
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 2,
      iconName: (
        <TimeFilterIcon
          bg={
            filterIconColorTime
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            filterIconColorTime
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 3,
      iconName: (
        <BatteryFilterIcon
          bg={
            filterIconColorBattery
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            filterIconColorBattery
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 4,
      iconName: (
        <BatteryFilterIcon
          bg={
            filterIconColorBatteryRed
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            filterIconColorBatteryRed
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },
  ];

  useEffect(() => {
    showFilteredCars();
  }, [
    filterIconColor,
    filterIconColorBattery,
    filterIconColorTime,
    filterIconColorBatteryRed,
    fleetCars,
    marshalCars,
    memberCars,
    memberSpecialCars,
    beverageCars,
    carsNotCommunicating,
    notInUseCars,
    specialCars,
    siteIdGetter
  ]);

  useEffect(() => {
    if (showTaggedCarArray.get().length !== 0) {
      let carsData = showTaggedCarArray
        .get()
        .filter((item, index, arr) => arr.indexOf(item) === index);
      showTaggedCarArrayLength.set(carsData);
    } else {
      showTaggedCarArrayLength.set(0);
    }
  }, [updateShowTaggedCarArrayLength]);

  const setCarsType = (value) => {
    let data = [...carsType];
    if (!data.includes(value)) {
      data.push(value);
    } else {
      const index = data.indexOf(value);
      data.splice(index, 1);
    }
    setCarsTypeData(data);
  }

  const showFilteredCars = () => {
    let getCarsData = JSON.parse(JSON.stringify(getSelectedCarsState.get()));
    let filterCars = [...getCarsData];
    let tagCars =
      filterCars && filterCars.length !== 0
        ? filterCars.filter((it) =>
          showTaggedCarArray.get().some((item) => item === it.Car.CarNumber)
        )
        : [];

    setHighlightCar(
      tagCars && tagCars.length !== 0
        ? tagCars.map((it) => it.Car.CarNumber)
        : []
    );
    setCarsToDisplay(filterCars);
  }

  const setTagCarOnMap = (carNumber) => {
    const doesHighlightCarExist = highlightCar.find((item) => item === carNumber);

    if (doesHighlightCarExist) {
      let newData = highlightCar.filter((item) => item !== carNumber);

      setHighlightCar(newData);
    } else {
      setHighlightCar([...highlightCar, carNumber]);
    }

    const doesShowTaggedCarArrayExist = showTaggedCarArray.get().find((item) => item === carNumber);

    if (doesShowTaggedCarArrayExist) {
      showTaggedCarArray.set((tasks) => tasks.filter((task) => task !== carNumber));
    } else {
      showTaggedCarArray.set((tasks) => [...tasks, carNumber]);
    }

    setUpdateShowTaggedCarArrayLength((prev) => !prev);

    const doesTempCarExist = tempCar.find((item) => item === carNumber);

    if (doesTempCarExist) {
      let newData = tempCar.filter((item) => item !== carNumber);

      setTempCar(newData);
    } else {
      setTempCar([...tempCar, carNumber]);
    }
  }

  const tagAndMessageFunction = (functionType) => {
    if (functionType === "tag") {
      showTagCarsState.set(false);
      taggedCarsSaverGlobalState.set([...showTaggedCarArray.get()]);
      taggedCarsSaverGlobalStateMaintainer.set([...showTaggedCarArray.get()]);
      if (taggedCarsSaverGlobalState.get().length > 0) findCars.set(true);
      if (pathname === "/fleet") {
        if (taggedCarsSaverGlobalState.get().length !== 0) {
          selectedCarList.set([...taggedCarsSaverGlobalState.get()]);
        } else {
          selectedCarList.set([...showTaggedCarArray.get()]);
        }
      }
      if (
        pathname === "/fleet" &&
        taggedCarsSaverGlobalState.get().length !== 0
      ) {
        highlightTagCar.set(true);
        taggedCarsDisplayerGlobalState.set(true);
        subNavDataState.set("MAP");
        sideDrawerActiveTabState.set(1);
        localStorage.setItem(
          "taggedCarsData",
          JSON.stringify({
            findCars: findCars.get(),
            taggedCarsDisplayerGlobalState:
              taggedCarsDisplayerGlobalState.get(),
            tagCarsDataMap: taggedCarsSaverGlobalState.get(),
            tagCarsDataFilters: showTaggedCarArray.get(),
          })
        );
        selectedCarList.set([]);
        selectedCarList2.set([]);
        carsForMessagesGetter.set([]);
        carsGpsSelectorData.set([]);
        carsForMessagesGetter2.set([]);
        carsGpsSelectorData2.set([]);
        navigate("/map");
      } else {
        highlightTagCar.set(true);
        taggedCarsDisplayerGlobalState.set(true);
        localStorage.setItem(
          "taggedCarsData",
          JSON.stringify({
            findCars: findCars.get(),
            taggedCarsDisplayerGlobalState:
              taggedCarsDisplayerGlobalState.get(),
            tagCarsDataMap: taggedCarsSaverGlobalState.get(),
            tagCarsDataFilters: showTaggedCarArray.get(),
          })
        );
      }
    } else {
      setCarsTypeData([1, 3]);
      setFleetCars(false);
      setSpecialCars(false);
      setMemberCars(false);
      setMemberSpecialCars(false);
      setMarshalCars(false);
      setNotInUseCars(false);
      setCarsNotCommunicating(false);
      setBeverageCars(false);
      setFilterIconColor(false);
      setFilterIconColorBattery(false);
      setFilterIconColorTime(false);
      setFilterIconColorBatteryRed(false);
      taggedCarsDisplayerGlobalState.set(false);
      highlightTagCar.set(false);
      allTaggedCars.set([]);
      setSearchInput("");
      setHighlightCar([]);
    }
  }

  const selectCarsData = (selectionType) => {
    if (selectionType === "all" && carsToDisplay.length !== 0) {
      let cars = carsToDisplay.map((it) => it.Car.CarNumber);
      setHighlightCar(cars);

      showTaggedCarArray.set(cars);
      taggedCarsDisplayerGlobalState.set(true);
    } else {
      setHighlightCar([]);

      taggedCarsDisplayerGlobalState.set(false);
      showTaggedCarArray.set([]);
    }

    setUpdateShowTaggedCarArrayLength((prev) => !prev);
  }

  const findCarsPopup = () => {
    showTagCarsState.set(!showTagCarsState.get());
  }

  const handleCancel = () => {
    if (pathname === "/fleet") {
      showTagCarsState.set(false);
      showTaggedCarArray.set([
        ...taggedCarsSaverGlobalState.get(),
        ...selectedCarList.get(),
      ]);
    } else {
      showTagCarsState.set(false);
      showTaggedCarArray.set([...taggedCarsSaverGlobalState.get()]);
    }

    setUpdateShowTaggedCarArrayLength((prev) => !prev);
  }

  const resetData = () => {
    setFilterIconColor(false);
    setFilterIconColorTime(false);
    setFilterIconColorBattery(false);
    setFilterIconColorBatteryRed(false);
    setFleetCars(true);
    setMarshalCars(true);
    setBeverageCars(true);
    setSpecialCars(true);
    enableMemberCar && setMemberCars(true);
    enableMemberCar && setMemberSpecialCars(true);
    setCarsNotCommunicating(true);
    setNotInUseCars(true);
    setSearchInput("");
    taggedCarsSaverGlobalState.set([]);
    taggedCarsDisplayerGlobalState.set(false);
    showTaggedCarArray.set([]);
    setUpdateShowTaggedCarArrayLength((prev) => !prev);
    findCars.set(false);
    localStorage.setItem(
      "taggedCarsData",
      JSON.stringify({
        findCars: false,
        taggedCarsDisplayerGlobalState: false,
        tagCarsDataMap: [],
        tagCarsDataFilters: [],
      })
    );
  }

  const handleCarStatusTitle = (item) => {
    return item.id === 1 ? t("Cars_Pace_Warning") : item.id === 2 ? t("Cars_Pace_Critical") : item.id === 3 ? t("Cars_Battery_Warning") : t("Cars_Battery_Critical")
  }

  const handleCarStatusClick = (item) => {
    if (item.id == 1) {
      setFilterIconColor(!filterIconColor);
      if (!filteredData.includes(item.id)) {
        filteredData.push(item.id);
      } else {
        const index = filteredData.indexOf(item.id);
        filteredData.splice(index, 1);
      }
    } else if (item.id == 2) {
      setFilterIconColorTime(!filterIconColorTime);
      if (!filteredData.includes(item.id)) {
        filteredData.push(item.id);
      } else {
        const index = filteredData.indexOf(item.id);
        filteredData.splice(index, 1);
      }
    } else if (item.id == 3) {
      setFilterIconColorBattery(
        !filterIconColorBattery
      );
      if (!filteredData.includes(item.id)) {
        filteredData.push(item.id);
      } else {
        const index = filteredData.indexOf(item.id);
        filteredData.splice(index, 1);
      }
    } else {
      setFilterIconColorBatteryRed(
        !filterIconColorBatteryRed
      );
      if (!filteredData.includes(item.id)) {
        filteredData.push(item.id);
      } else {
        const index = filteredData.indexOf(item.id);
        filteredData.splice(index, 1);
      }
    }
  }

  return (
    <>
      <Modal
        open={showTagCarsState.get()}
        onClose={findCarsPopup}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <SelectTagCar className={pathname === "/fleet" && "fleet-find-car-section"}>
            <div className="inner-wrapper">
              <div className="box-heading">
                <h5>{t("Find_Cars")}</h5>
                <CloseIcon
                  width={22}
                  height={22}
                  onClick={() => findCarsPopup()}
                />
              </div>

              <div className="filter">
                <p>{t("Filters")}</p>
                <div>
                  {carStatusData &&
                    carStatusData.map((item, index) => (
                      <Tooltip  key={`filter-1-${index + 1}`} title={handleCarStatusTitle(item)} placement="top" arrow>
                        <button key={item.id} onClick={() => handleCarStatusClick(item)}>
                          {item.iconName}
                        </button>
                      </Tooltip>
                    ))}
                </div>
              </div>

              <div className="white-filter">
                <Tooltip title={t("Fleet_cars")} placement="top" arrow>
                  <button onClick={() => { setFleetCars(!fleetCars); }}>

                    <FilterCarIcon
                      bgcolor={fleetCars ? "var(--theme-background)" : "var(--input-background)"}
                      color={fleetCars ? "var(--input-background)" : "var(--text-secondary)"}
                      border={fleetCars ? "#FFE500" : "#707374"}
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Special_needs_cars")} placement="top" arrow>
                  <button onClick={() => { setSpecialCars(!specialCars); }}>

                    <FilterFlagIcon bgcolor={specialCars ? "var(--theme-background)" : "var(--input-background)"}
                      color={specialCars ? "var(--input-background)" : "#0026AC"}
                      border={specialCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Marshal_cars")} placement="top" arrow>
                  <button onClick={() => { setMarshalCars(!marshalCars); }}>
                    {" "}

                    <FilterShildIcon bgcolor={marshalCars ? "var(--theme-background)" : "var(--input-background)"}
                      color={marshalCars ? "var(--input-background)" : "#49B3E0"}
                      border={marshalCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Beverage_cars")} placement="top" arrow>
                  <button onClick={() => { setBeverageCars(!beverageCars); }}>

                    <FilterDineIcon bgcolor={beverageCars ? "var(--theme-background)" : "var(--input-background)"}
                      color={beverageCars ? "var(--input-background)" : "#229D08"}
                      border={beverageCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
                    />
                  </button>
                </Tooltip>
                {enableMemberCar && <><Tooltip title={t("Member_car")} placement="top" arrow>
                  <button onClick={() => { setMemberCars(!memberCars); }}>

                    <MembercarIcon
                      width={30}
                      height={30}
                      bg={memberCars ? "var(--theme-background)" : "var(--input-background)"}
                      color={memberCars ? "var(--input-background)" : "#00A000"}
                      stroke={memberCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
                    />
                  </button>
                </Tooltip>
                  <Tooltip title={t("Member_/_Special_Needs")} placement="top" arrow>
                    <button onClick={() => { setMemberSpecialCars(!memberSpecialCars) }}>
                      <div style={{ display: "inline-flex", gap: 1 }}>
                        <MembercarIcon
                          width={30}
                          height={30}
                          bg={memberSpecialCars ? "var(--theme-background)" : "var(--input-background)"}
                          color={memberSpecialCars ? "var(--input-background)" : "#00A000"}
                          stroke={memberSpecialCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
                        />

                        <SpecialNeedsIcon width={20} height={30} bg={memberSpecialCars ? "var(--theme-background)" : "#0026AC"} />
                      </div>
                    </button>
                  </Tooltip></>}
                <Tooltip title={t("Cars_not_in_use")} placement="top" arrow>
                  <button onClick={() => { setNotInUseCars(!notInUseCars); }}>
                    <FilterBlockIcon
                      bgcolor={notInUseCars ? "var(--theme-background)" : "var(--input-background)"}
                      color={notInUseCars ? "var(--input-background)" : "#FA3C30"}
                      border={notInUseCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Cars_not_communicating")} placement="top" arrow>
                  <button className={carsNotCommunicating ? "active not-com" : " not-com"} onClick={() => { setCarsNotCommunicating(!carsNotCommunicating); }}>
                    <FilterTagsIcon
                      bgcolor={carsNotCommunicating ? "var(--theme-background)" : "var(--input-background)"}
                      color={carsNotCommunicating ? "var(--input-background)" : "#3134EB"}
                      border={carsNotCommunicating ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
                      fill={carsNotCommunicating ? "var(--theme-background)" : "var(--input-background)"}
                    />
                  </button>
                </Tooltip>
              </div>

              <div className="search-wrapper">
                <input
                  placeholder={t("Search_car_no")}
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <SearchIcon color="#999999" />
              </div>

              <div className="car-selection">
                <div className="car-count">
                  <div>
                    <p onClick={() => selectCarsData("all")}>{t("All")}</p> I{" "}
                    <p onClick={() => selectCarsData("none")}>{t("None")}</p>
                  </div>
                  <div>
                    {showTaggedCarArrayLength.get().length &&
                      carsToDisplay.filter((it) => showTaggedCarArray.get().some((item) => item === it.Car.CarNumber))?.length
                      ? showTaggedCarArrayLength.get().length &&
                      carsToDisplay.filter((it) => showTaggedCarArray.get().some((item) => item === it.Car.CarNumber))?.length
                      : 0}
                    &nbsp;
                    {showTaggedCarArrayLength.get().length > 1
                      ? t("cars_selected")
                      : t("car_selected")}
                  </div>
                </div>

                <div
                  className="car-number"
                  style={{
                    maxHeight: 116,
                    overflow: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  {carsToDisplay && carsToDisplay.length > 0 ? (
                    carsToDisplay
                      .filter((item) => {
                        if (searchInput === "") {
                          return item.Car.CarNumber;
                        } else if (
                          item.Car.CarNumber.toString()
                            .toLowerCase()
                            .includes(searchInput.toLowerCase())
                        ) {
                          return item.Car.CarNumber;
                        }
                      })
                      .sort((a, b) => a.Car.CarNumber - b.Car.CarNumber)
                      .map((item, index) => (
                        <Tooltip
                          key={`cars-to-display-1-${index + 1}`}
                          title={item.Car.CarNumber.toString()}
                          placement="top"
                        >
                          <button
                            className={showTaggedCarArray.get().includes(item.Car.CarNumber) ? "active" : ""}
                            onClick={() => setTagCarOnMap(item.Car.CarNumber)}
                          >
                            {item.Car.CarNumber}
                          </button>
                        </Tooltip>
                      ))
                  ) : (
                    <p>No car number found</p>
                  )}
                </div>
                <MsgToCar>
                  <div className="action-wrapper">
                    <Button
                      variant="outlined"
                      className={
                        showTaggedCarArrayLength.get().length > 0
                          ? "active"
                          : " active disabled"
                      }
                      onClick={() => tagAndMessageFunction("tag")}
                    >
                      {t("Find_car")}
                    </Button>
                    <button className="send-btn" onClick={handleCancel}>
                      {t("Cancel")}
                    </button>
                    <button className="send-btn" onClick={resetData}>
                      {t("Reset")}
                    </button>
                  </div>
                </MsgToCar>
              </div>
            </div>
          </SelectTagCar>
        </Box>
      </Modal>
      {showTagCarsFromMapState.get() && !showTagCarsState.get() && (
        <>
          <SelectTagCar
            className={pathname === "/fleet" && "fleet-find-car-section"}
          >
            <div className="inner-wrapper">
              <div className="box-heading">
                <h5>{t("Find_Cars")}</h5>
                <div className="close-icon-wrapper-mobile">
                  <CloseIcon
                    width={22}
                    height={22}
                    onClick={() => showTagCarsFromMapState.set(false)}
                  />
                </div>
                {/* )} */}
              </div>
              <div className="filter">
                <p>{t("Filters")}</p>
                <div>
                  {carStatusData &&
                    carStatusData.map((item, index) => (
                      <Tooltip
                        key={`filter-2-${index + 1}`}
                        title={handleCarStatusTitle(item)}
                        placement="top"
                        arrow
                      >
                        <button key={item.id} onClick={() => handleCarStatusClick(item)}>
                          {item.iconName}
                        </button>
                      </Tooltip>
                    ))}
                </div>
              </div>
              <div className="white-filter">
                <Tooltip title={t("Fleet_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(1);
                      setFleetCars(!fleetCars);
                    }}
                  >
                    <FilterCarIcon
                      bgcolor={
                        fleetCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        fleetCars
                          ? "var(--input-background)"
                          : "var(--text-secondary)"
                      }
                      border={fleetCars ? "#FFE500" : "#707374"}
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Special_needs_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(3);
                      setSpecialCars(!specialCars);
                    }}
                  >
                    <FilterFlagIcon
                      bgcolor={
                        specialCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        specialCars ? "var(--input-background)" : "#0026AC"
                      }
                      border={
                        specialCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Marshal_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(2);
                      setMarshalCars(!marshalCars);
                    }}
                  >
                    {" "}
                    <FilterShildIcon
                      bgcolor={
                        marshalCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        marshalCars ? "var(--input-background)" : "#49B3E0"
                      }
                      border={
                        marshalCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Beverage_cars")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(4);
                      setBeverageCars(!beverageCars);
                    }}
                  >
                    <FilterDineIcon
                      bgcolor={
                        beverageCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        beverageCars ? "var(--input-background)" : "#229D08"
                      }
                      border={
                        beverageCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                {enableMemberCar && <><Tooltip title={t("Member_car")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setMemberCars(!memberCars);
                    }}
                  >
                    <MembercarIcon
                      width={30}
                      height={30}
                      bg={
                        memberCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={memberCars ? "var(--input-background)" : "#00A000"}
                      stroke={memberCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"}
                    />

                  </button>
                </Tooltip>
                  <Tooltip title={t("Member_/_Special_Needs")} placement="top" arrow>
                    <button onClick={() => {
                      setMemberSpecialCars(!memberSpecialCars)
                    }}>
                      <div style={{ display: "inline-flex", gap: 1 }}>  <MembercarIcon
                        width={30}
                        height={30}
                        bg={
                          memberSpecialCars
                            ? "var(--theme-background)"
                            : "var(--input-background)"
                        }
                        color={memberSpecialCars ? "var(--input-background)" : "#00A000"}
                        stroke={memberSpecialCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"}
                      />
                        <SpecialNeedsIcon width={20} height={30}
                          bg={
                            memberSpecialCars
                              ? "var(--theme-background)"
                              : "#0026AC"
                          }
                        />
                      </div>
                    </button>
                  </Tooltip></>
                }
                <Tooltip title={t("Cars_not_in_use")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setCarsType(5);
                      setNotInUseCars(!notInUseCars);
                    }}
                  >
                    <FilterBlockIcon
                      bgcolor={
                        notInUseCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        notInUseCars ? "var(--input-background)" : "#FA3C30"
                      }
                      border={
                        notInUseCars
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip
                  title={t("Cars_not_communicating")}
                  placement="top"
                  arrow
                >
                  <button
                    className={carsNotCommunicating ? "active not-com" : " not-com"}
                    onClick={() => {
                      setCarsType(carType.member);
                      setCarsNotCommunicating(!carsNotCommunicating);
                    }}
                  >
                    <FilterTagsIcon
                      bgcolor={
                        carsNotCommunicating
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={
                        carsNotCommunicating
                          ? "var(--input-background)"
                          : "#3134EB"
                      }
                      border={
                        carsNotCommunicating
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                      fill={
                        carsNotCommunicating
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                    />
                  </button>
                </Tooltip>
              </div>
              <div className="search-wrapper">
                <input
                  placeholder={t("Search_car_no")}
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <SearchIcon color="#999999" />
              </div>
              <div className="car-selection">
                <div className="car-count">
                  <div>
                    <p onClick={() => selectCarsData("all")}>{t("All")}</p> I{" "}
                    <p onClick={() => selectCarsData("none")}>{t("None")}</p>
                  </div>

                  <div>
                    {showTaggedCarArrayLength.get().length &&
                      carsToDisplay.filter((it) =>
                        showTaggedCarArray
                          .get()
                          .some((item) => item === it.Car.CarNumber)
                      )?.length
                      ? showTaggedCarArrayLength.get().length &&
                      carsToDisplay.filter((it) =>
                        showTaggedCarArray
                          .get()
                          .some((item) => item === it.Car.CarNumber)
                      )?.length
                      : 0}
                    &nbsp;
                    {showTaggedCarArrayLength.get().length > 1
                      ? t("cars_selected")
                      : t("car_selected")}
                  </div>
                </div>

                <div
                  className="car-number"
                  style={{
                    maxHeight: 116,
                    overflow: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  {carsToDisplay && carsToDisplay.length > 0 ? (
                    carsToDisplay
                      .filter((item) => {
                        if (searchInput === "") {
                          return item.Car.CarNumber;
                        } else if (
                          item.Car.CarNumber.toString()
                            .toLowerCase()
                            .includes(searchInput.toLowerCase())
                        ) {
                          return item.Car.CarNumber;
                        }
                      })
                      .sort((a, b) => a.Car.CarNumber - b.Car.CarNumber)
                      .map((item, index) => (
                        <Tooltip
                          key={`cars-to-display-2-${index + 1}`}
                          title={item.Car.CarNumber.toString()}
                          placement="top"
                        >
                          <button
                            className={showTaggedCarArray.get().includes(item.Car.CarNumber) ? "active" : ""}
                            onClick={() => setTagCarOnMap(item.Car.CarNumber)}
                          >
                            {item.Car.CarNumber}
                          </button>
                        </Tooltip>
                      ))
                  ) : (
                    <p>No car number found</p>
                  )}
                </div>
                <MsgToCar>
                  <div className="action-wrapper">
                    <Button
                      variant="outlined"
                      className={
                        showTaggedCarArrayLength.get().length > 0
                          ? "active"
                          : " active disabled"
                      }
                      onClick={() => tagAndMessageFunction("tag")}
                    >
                      {t("Find_car")}
                    </Button>
                    {!showTagCarsFromMapState.get() &&
                      showTagCarsState.get() && (
                        <button className="send-btn" onClick={handleCancel}>
                          {t("Cancel")}
                        </button>
                      )}

                    <button className="send-btn" onClick={resetData}>
                      {t("Reset")}
                    </button>
                  </div>
                </MsgToCar>
              </div>
            </div>
          </SelectTagCar>
        </>
      )}
    </>
  );
};

//Change Car Setting Component
export { ChangeSettingsForSelectedCars as TagCarsComponent1 };

// Click to Drive Component

export const ClickToDriveComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const {
    allTaggedCars,
    highlightTagCar,
    showTaggedCarArrayClickToDrive,
    taggedCarsDisplayerGlobalState,
    showClickToDriveWindow,
    enableClickToDriveFeature,
    showTaggedCarArrayClickToDriveInputShower,
    showTaggedGpsArray,
    showTaggedCarArrayClickToDriveInputValueSetter,
  } = useHookstate(MAP_GLOBAL_STATES);
  const {
    notCommunicatingCarEnabled,
    paceStatusWarning,
    paceStatusCritical,
    warningBatteryLevel,
    criticalBatteryLevel,
  } = useHookstate(APP_CONSTANTS_STATE);

  const { getUserRole, siteSettingsData } = useSelector((state) => state.commonReducers) || [];

  const enableMemberCar = (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  ));

  const [fleetCars, setFleetCars] = useState(true);
  const [specialCars, setSpecialCars] = useState(true);
  const [marshalCars, setMarshalCars] = useState(true);
  const [beverageCars, setBeverageCars] = useState(true);
  const [notInUseCars, setNotInUseCars] = useState(true);
  const [carsNotCommunicating, setCarsNotCommunicating] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [highlightCar, setHighlightCar] = useState([]);
  const [filterIconColor, setFilterIconColor] = useState(false);
  const [filterIconColorTime, setFilterIconColorTime] = useState(false);
  const [filterIconColorBattery, setFilterIconColorBattery] = useState(false);
  const [filterIconColorBatteryRed, setFilterIconColorBatteryRed] = useState(false);
  const [carsToDisplay, setCarsToDisplay] = useState([]);
  const [memberCars, setMemberCars] = useState(enableMemberCar);
  const [memberSpecialCars, setMemberSpecialCars] = useState(enableMemberCar);
  const [featuresResortEdition] = useState(false);

  const { getSelectedCarsState } = useFilteredCarsHook({
    marshalCars: marshalCars,
    specialCars: specialCars,
    memberCars: memberCars,
    beverageCars: beverageCars,
    fleetCars: fleetCars,
    notInUseCars: notInUseCars,
    notCommunicatingCars: carsNotCommunicating,
    paceWarning: filterIconColor,
    paceCritical: filterIconColorTime,
    batteryWarning: filterIconColorBattery,
    batteryCritical: filterIconColorBatteryRed,
    carsInEnergySaverMode: true
  });

  useEffect(() => {
    filterCarList();
  }, [
    fleetCars,
    specialCars,
    memberCars,
    marshalCars,
    beverageCars,
    notInUseCars,
    carsNotCommunicating,
    filterIconColor,
    filterIconColorTime,
    filterIconColorBattery,
    filterIconColorBatteryRed,
  ]);

  useEffect(() => {
    filterCarList();
  }, [updatedCarData.get()]);

  useEffect(() => {
    if (localStorage.getItem("TaggedCarsData")) {
      let array = localStorage.getItem("TaggedCarsData").split(",");
      array = array.map((data) => parseInt(data));
      showTaggedCarArrayClickToDrive.set(array);
    }
  }, []);

  const carStatusData = [
    {
      id: 1,
      iconName: (
        <TimeFilterIcon
          bg={
            filterIconColor
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            filterIconColor
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 2,
      iconName: (
        <TimeFilterIcon
          bg={
            filterIconColorTime
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            filterIconColorTime
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 3,
      iconName: (
        <BatteryFilterIcon
          bg={
            filterIconColorBattery
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            filterIconColorBattery
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 4,
      iconName: (
        <BatteryFilterIcon
          bg={
            filterIconColorBatteryRed
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            filterIconColorBatteryRed
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },
  ];

  useState(() => {
    dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
  }, [siteId.get()]);

  let staleTimeInMinutes = 15;

  const setTagCarOnMap = (car) => {
    const doesHighlightCarExist = highlightCar.find((item) => item === car.CarNumber);

    if (doesHighlightCarExist) {
      let newData = highlightCar.filter((item) => item !== car.CarNumber);
      setHighlightCar(newData);
    } else {
      setHighlightCar([...highlightCar, car.CarNumber]);
    }

    const doesShowTaggedCarArrayClickToDriveExist = showTaggedCarArrayClickToDrive.get().find((item) => item === car.CarNumber);

    if (doesShowTaggedCarArrayClickToDriveExist) {
      showTaggedCarArrayClickToDrive.set((tasks) =>
        tasks.filter((task) => task !== car.CarNumber)
      );
    } else {
      showTaggedCarArrayClickToDrive.set((tasks) => [...tasks, car.CarNumber]);
    }

    showTaggedGpsArray.set(car.GpsiCarId);
  }

  const tagAndMessageFunction = (functionType) => {
    if (functionType === "tag") {
      showClickToDriveWindow.set(false);

      const newTaggedCars = carsToDisplay
        ?.filter((it) =>
          showTaggedCarArrayClickToDrive
            ?.get()
            .some((item) => item === it.Car.CarNumber)
        )
        .map((it) => it.Car.CarNumber);

      showTaggedCarArrayClickToDrive.set(newTaggedCars);

      highlightTagCar.set(true);
      localStorage.setItem("TaggedCarsData", [
        ...showTaggedCarArrayClickToDrive.get(),
      ]);
      showTaggedCarArrayClickToDriveInputValueSetter.set([
        ...showTaggedCarArrayClickToDrive.get(),
      ]);
      showTaggedCarArrayClickToDriveInputShower.set(true);
    } else {
      showTaggedCarArrayClickToDrive.set(
        showTaggedCarArrayClickToDriveInputValueSetter.get().length !== 0
          ? [...showTaggedCarArrayClickToDriveInputValueSetter.get()]
          : []
      );
      setFleetCars(true);
      setSpecialCars(true);
      enableMemberCar && setMemberCars(true);
      enableMemberCar && setMemberSpecialCars(true);
      setMarshalCars(false);
      setNotInUseCars(false);
      setCarsNotCommunicating(false);
      setBeverageCars(false);
      setFilterIconColor(false);
      setFilterIconColorBattery(false);
      setFilterIconColorTime(false);
      setFilterIconColorBatteryRed(false);
      showClickToDriveWindow.set(false);
      taggedCarsDisplayerGlobalState.set(false);
      enableClickToDriveFeature.set(false);
      highlightTagCar.set(false);
      allTaggedCars.set([]);
      setSearchInput("");
      setHighlightCar([]);
    }
  }

  const selectCarsData = (selectionType) => {
    if (selectionType === "all" && carsToDisplay.length !== 0) {
      let cars = carsToDisplay.map((it) => it.Car.CarNumber);
      setHighlightCar(cars);
      showTaggedCarArrayClickToDrive.set(cars);
    } else {
      setHighlightCar([]);
      showTaggedCarArrayClickToDrive.set([]);
    }
  }

  const isCarInUse = (car, includeNotPlaying, includeNoComm, includeCharging) => {
    // If marked out-of-service, never count as in use
    if (car?.Car?.CarType === carType.outOfService) return false;

    // Must have reported position within last XX minutes to count
    let ageInMinutes = moment().diff(
      moment.utc(car?.Car?.LastLocationUpdateInUtc),
      "minutes"
    ); // JFG: I don't think .utc is necessary here
    if (ageInMinutes > staleTimeInMinutes) return false;

    if (
      car?.Car?.DevType !== deviceType.FT ||
      car?.Car?.DevType !== deviceType.WT
    ) {
      // For all cars, must be off charge and have a valid lat/long
      if (
        car?.Car?.IsCharging ||
        !isValidLocation(car?.Car?.Latitude, car?.Car?.Longitude)
      )
        return false;

      if (featuresResortEdition) {
        // For regular and special needs car, must have a guest name and/or suite assigned to count as "in use"
        if (
          car?.Car?.CarType !== carType?.marshal &&
          car?.Car?.CarType !== carType?.bevcart
        )
          if (!car?.Car?.PlayerName1 && !car?.Car?.PlayerName2) return false;
      } else {
        // For regular golfers and special needs, must be on a hole to count as "in use"
        if (
          car?.Car?.HoleLocation === holeLocation.unknown &&
          car?.Car?.CarType !== carType.marshal &&
          car?.Car?.CarType !== carType.bevcart
        )
          return false; // not on hole, not a marshal, not a beverage cart === not in use
      }
    } else {
      if (!isValidLocation(car?.Car?.Latitude, car?.Car?.Longitude)) {
        return false;
      }
    }

    return true; // in use!
  }

  const filterCarList = () => {
    if (updatedCarData.get() && updatedCarData.get().length !== 0) {
      let allCars = JSON.parse(updatedCarData && updatedCarData.get());
      let tempArray = [];
      let batteryAndPace = [];
      if (allCars && allCars.length !== 0) {
        for (let i = 0; i < allCars.length; i++) {
          let carTypeHasExplicitFilter =
            allCars[i]?.Car?.CarType === carType?.marshal ||
            allCars[i]?.Car?.CarType === carType?.handicap ||
            allCars[i]?.Car?.CarType === carType?.member ||
            allCars[i]?.Car?.CarType === carType?.bevcart ||
            allCars[i]?.Car?.CarType === carType?.member;
          if (carsNotCommunicating) {
            if (
              (marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
              (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
              (memberCars && allCars[i]?.Car?.CarType === carType?.member) ||
              (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
              (fleetCars &&
                isCarInUse(allCars[i]) &&
                !carTypeHasExplicitFilter) ||
              (carsNotCommunicating && allCars[i]?.Car?.Connection === 2) ||
              (notInUseCars && !isCarInUse(allCars[i]))
            ) {
              tempArray.push(allCars[i]);
            }
          } else if (
            !carsNotCommunicating &&
            allCars[i]?.Car?.Connection !== notCommunicatingCarEnabled.get()
          ) {
            if (
              (marshalCars && allCars[i]?.Car?.CarType === carType?.marshal) ||
              (specialCars && allCars[i]?.Car?.CarType === carType?.handicap) ||
              (memberCars && allCars[i]?.Car?.CarType === carType?.member) ||
              (beverageCars && allCars[i]?.Car?.CarType === carType?.bevcart) ||
              (fleetCars &&
                isCarInUse(allCars[i]) &&
                !carTypeHasExplicitFilter) ||
              (notInUseCars && !isCarInUse(allCars[i]))
            ) {
              tempArray.push(allCars[i]);
            }
          }
        }

        if (tempArray && tempArray.length !== 0) {
          for (var i = 0; i < tempArray.length; i++) {
            if (
              filterIconColor ||
              filterIconColorTime ||
              filterIconColorBattery ||
              filterIconColorBatteryRed
            ) {
              if (
                (filterIconColor &&
                  tempArray[i]?.Car?.PaceStatus === paceStatusWarning.get()) ||
                (filterIconColorTime &&
                  tempArray[i]?.Car?.PaceStatus === paceStatusCritical.get()) ||
                (filterIconColorBattery &&
                  tempArray[i]?.Car?.BatteryLevel >
                  criticalBatteryLevel.get() &&
                  tempArray[i]?.Car?.BatteryLevel <=
                  warningBatteryLevel.get() &&
                  !tempArray[i]?.Car?.IsCharging) ||
                (filterIconColorBatteryRed &&
                  tempArray[i]?.Car?.BatteryLevel <=
                  criticalBatteryLevel.get() &&
                  !tempArray[i]?.Car?.IsCharging)
              ) {
                batteryAndPace.push(tempArray[i]);
              }
            } else {
              batteryAndPace.push(tempArray[i]);
            }
          }
        }
      }
      setCarsToDisplay(batteryAndPace);
    } else {
      setCarsToDisplay([]);
    }
  }

  const handelResetMessage = () => {
    selectCarsData("none");
    setSearchInput("");
    setFleetCars(true);
    setSpecialCars(true);
    enableMemberCar && setMemberCars(true);
    enableMemberCar && setMemberSpecialCars(true);
    setMarshalCars(true);
    setBeverageCars(true);
    setNotInUseCars(true);
    setCarsNotCommunicating(true);
    setFilterIconColor(false);
    setFilterIconColorTime(false);
    setFilterIconColorBattery(false);
    setFilterIconColorBatteryRed(false);
    tagAndMessageFunction("tag");
    showClickToDriveWindow.set(true);
  }

  const handleCarStatusTitle = (item) => {
    return item.id === 1 ? t("Cars_Pace_Warning") : item.id === 2 ? t("Cars_Pace_Critical") : item.id === 3 ? t("Cars_Battery_Warning") : t("Cars_Battery_Critical")
  }

  const handleCarStatusClick = (item) => {
    if (item.id == 1) {
      setFilterIconColor(!filterIconColor);
    } else if (item.id == 2) {
      setFilterIconColorTime(!filterIconColorTime);
    } else if (item.id == 3) {
      setFilterIconColorBattery(!filterIconColorBattery);
    } else {
      setFilterIconColorBatteryRed(!filterIconColorBatteryRed);
    }
  }

  return (
    <>
      <SelectTagCar>
        <div className="inner-wrapper">
          <div className="filter">
            <p>{t("Filters")}</p>
            <div>
              {carStatusData &&
                carStatusData.map((item, index) => (
                  <Tooltip
                    key={`filter-3-${index + 1}`}
                    title={handleCarStatusTitle(item)}
                    placement="top"
                    arrow
                  >
                    <button
                      key={item.id}
                      onClick={() => handleCarStatusClick(item)}
                    >
                      {item.iconName}
                    </button>
                  </Tooltip>
                ))}
            </div>
          </div>

          <div className="white-filter">
            <Tooltip title={t("Fleet_cars")} placement="top" arrow>
              <button
                onClick={() => {
                  setFleetCars(!fleetCars);
                }}
              >
                <FilterCarIcon
                  bgcolor={
                    fleetCars
                      ? "var(--theme-background)"
                      : "var(--input-background)"
                  }
                  color={
                    fleetCars
                      ? "var(--input-background)"
                      : "var(--text-secondary)"
                  }
                  border={fleetCars ? "#FFE500" : "#707374"}
                />
              </button>
            </Tooltip>
            <Tooltip title={t("Special_needs_cars")} placement="top" arrow>
              <button
                onClick={() => {
                  setSpecialCars(!specialCars);
                }}
              >
                <FilterFlagIcon
                  bgcolor={
                    specialCars
                      ? "var(--theme-background)"
                      : "var(--input-background)"
                  }
                  color={specialCars ? "var(--input-background)" : "#0026AC"}
                  border={
                    specialCars
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"
                  }
                />
              </button>
            </Tooltip>
            <Tooltip title={t("Marshal_cars")} placement="top" arrow>
              <button
                onClick={() => {
                  setMarshalCars(!marshalCars);
                }}
              >
                <FilterShildIcon
                  bgcolor={
                    marshalCars
                      ? "var(--theme-background)"
                      : "var(--input-background)"
                  }
                  color={marshalCars ? "var(--input-background)" : "#49B3E0"}
                  border={
                    marshalCars
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"
                  }
                />
              </button>
            </Tooltip>
            <Tooltip title={t("Beverage_cars")} placement="top" arrow>
              <button
                onClick={() => {
                  setBeverageCars(!beverageCars);
                }}
              >
                <FilterDineIcon
                  bgcolor={
                    beverageCars
                      ? "var(--theme-background)"
                      : "var(--input-background)"
                  }
                  color={beverageCars ? "var(--input-background)" : "#229D08"}
                  border={
                    beverageCars
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"
                  }
                />
              </button>
            </Tooltip>

            {enableMemberCar && <><Tooltip title={t("Member_car")} placement="top" arrow>
              <button
                onClick={() => {
                  setMemberCars(!memberCars);
                }}
              >
                <MembercarIcon
                  width={30}
                  height={30}
                  stroke={"#947550"}
                  bg={memberCars ? "var(--theme-background)" : "var(--theme-text)"}
                  color={memberCars ? "var(--theme-text)" : "var(--theme-background)"}
                />
              </button>
            </Tooltip>
              <Tooltip title={t("Member_/_Special_Needs")} placement="top" arrow>
                <button onClick={() => {
                  setMemberSpecialCars(!memberSpecialCars)
                }}>
                  <div style={{ display: "inline-flex", gap: 1 }}> <MembercarIcon
                    width={30}
                    height={30}
                    bg={
                      memberSpecialCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={memberSpecialCars ? "var(--input-background)" : "#00A000"}
                    stroke={memberSpecialCars
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"}
                  />
                    <SpecialNeedsIcon width={20} height={30}
                      bg={
                        memberSpecialCars
                          ? "var(--theme-background)"
                          : "#0026AC"
                      }
                    />
                  </div>
                </button>
              </Tooltip></>}
            <Tooltip title={t("Cars_not_in_use")} placement="top" arrow>
              <button
                onClick={() => {
                  setNotInUseCars(!notInUseCars);
                }}
              >
                <FilterBlockIcon
                  bgcolor={
                    notInUseCars
                      ? "var(--theme-background)"
                      : "var(--input-background)"
                  }
                  color={notInUseCars ? "var(--input-background)" : "#FA3C30"}
                  border={
                    notInUseCars
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"
                  }
                />
              </button>
            </Tooltip>
            <Tooltip title={t("Cars_not_communicating")} placement="top" arrow>
              <button
                className={carsNotCommunicating ? "active not-com" : " not-com"}
                onClick={() => {
                  setCarsNotCommunicating(!carsNotCommunicating);
                }}
              >
                <FilterTagsIcon
                  bgcolor={
                    carsNotCommunicating
                      ? "var(--theme-background)"
                      : "var(--input-background)"
                  }
                  color={
                    carsNotCommunicating ? "var(--input-background)" : "#3134EB"
                  }
                  border={
                    carsNotCommunicating
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"
                  }
                />
              </button>
            </Tooltip>
          </div>

          <div className="car-selection">
            <div className="car-count">
              <div>
                <p onClick={() => selectCarsData("all")}>{t("All")}</p> I{" "}
                <p onClick={() => selectCarsData("none")}>{t("None")}</p>
              </div>
              <div>
                {showTaggedCarArrayClickToDrive.get().length &&
                  getSelectedCarsState
                    .get()
                    .filter((it) =>
                      showTaggedCarArrayClickToDrive
                        .get()
                        .some((item) => item === it.Car.CarNumber)
                    )?.length
                  ? showTaggedCarArrayClickToDrive.get().length &&
                  getSelectedCarsState
                    .get()
                    .filter((it) =>
                      showTaggedCarArrayClickToDrive
                        .get()
                        .some((item) => item === it.Car.CarNumber)
                    )?.length
                  : 0}
                &nbsp;
                {showTaggedCarArrayClickToDrive.get().length > 1
                  ? t("cars_selected")
                  : t("car_selected")}
              </div>
            </div>

            <div
              className="car-number"
              style={{
                maxHeight: 116,
                overflow: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              {getSelectedCarsState.get() &&
                getSelectedCarsState.get().length !== 0 ? (
                getSelectedCarsState
                  .get()
                  .filter((item) => {
                    if (searchInput === "") {
                      return item.Car.CarNumber;
                    } else if (
                      item.Car.CarNumber.toString()
                        .toLowerCase()
                        .includes(searchInput.toLowerCase())
                    ) {
                      return item.Car.CarNumber;
                    }
                  })
                  .sort((a, b) => a.Car.CarNumber - b.Car.CarNumber)
                  .map((item, index) => (
                    <Tooltip
                      key={`cars-to-display-3-${index + 1}`}
                      title={item.Car.CarNumber.toString()}
                      placement="top"
                    >
                      <button
                        className={showTaggedCarArrayClickToDrive.get().find((item3) => item3 === item.Car.CarNumber) ? "active" : ""}
                        onClick={() => setTagCarOnMap(item.Car)}
                      >
                        {item.Car.CarNumber}
                      </button>
                    </Tooltip>
                  ))
              ) : (
                <p>No Car Found</p>
              )}
            </div>
            <MsgToCar>
              <div className="action-wrapper">
                <button
                  className={
                    showTaggedCarArrayClickToDrive.get().length !== 0 ||
                      showTaggedCarArrayClickToDriveInputValueSetter.get()?.length
                      ? "active"
                      : "disabled"
                  }
                  onClick={() => tagAndMessageFunction("tag")}
                >
                  {t("Ok")}
                </button>
                <button
                  className="send-btn"
                  onClick={() => handelResetMessage()}
                >
                  {t("Reset")}
                </button>
                <button
                  className="send-btn"
                  onClick={() => tagAndMessageFunction("cancel")}
                >
                  {t("Cancel")}
                </button>
              </div>
            </MsgToCar>
          </div>
        </div>
      </SelectTagCar>
    </>
  );
};
